export enum DetailsTransactionsViewMode {
  Details,
  Transactions,
  Histories,
}

export interface IDetailsTransactionsSwitch {
  viewMode: DetailsTransactionsViewMode;
  setViewMode: (viewMode: DetailsTransactionsViewMode) => void;
}
export interface IShowInstallBanner {
  IsShowInstallBanner: boolean;
  setIsShowInstallBanner: (data: boolean) => void;
}

export type BuyCreditTab = 'rialBashgah' | 'loan';

export interface BuyCreditStore {
  activeTab: BuyCreditTab;
  setActiveTab: (tab: BuyCreditTab) => void;
}
